<ngx-loading [show]="disableGrid" id="gridDisableDiv"></ngx-loading>
<div class="container-fluid h-100 overflow-auto">
  <div *ngIf="clinic" class="row">
    <div class="col-xl-4 my-1">
      <div class="d-flex align-items-center teal-font bigger">
        <label class="switch">
          <input type="checkbox" [(ngModel)]="clinic.allowOnlineBooking" (change)="updateOnlineBooking()" />
          <span class="slider round"></span>
        </label>
        <span class="pl-2">Allow online booking</span>
      </div>
    </div>
    <div class="col-xl-8 my-1">
      <div class="teal-font bigger">
        Portal URL: <a [href]="portalUrl" target="_blank">{{ portalUrl }}</a>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-xl-4 my-1">
      <app-org-online-general-settings class="h-100" [clinic]="clinic"></app-org-online-general-settings>
    </div>
    <div class="col-xl-4 my-1">
      <app-org-online-providers-settings
        class="h-100"
        (disableGridEvent)="changeDisableGrid($event)"
      ></app-org-online-providers-settings>
    </div>
    <div class="col-xl-4 my-1">
      <app-org-online-categories-settings
        class="h-100"
        (disableGridEvent)="changeDisableGrid($event)"
      ></app-org-online-categories-settings>
    </div>
  </div>
  <div class="row">
    <div class="col my-1">
      <app-org-online-service-settings
        class="h-100"
        (disableGridEvent)="changeDisableGrid($event)"
      ></app-org-online-service-settings>
    </div>
  </div>
  <div class="row">
    <div class="col-xl-4 my-1">
      <app-org-portal-style-settings class="h-100" [(clinic)]="clinic"></app-org-portal-style-settings>
    </div>
    <div class="col-xl-8 my-1">
      <app-org-portal-style-preview class="h-100" [clinic]="clinic"></app-org-portal-style-preview>
    </div>
  </div>
</div>

<app-actionpanel></app-actionpanel>
